// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-container {
  padding: 24px;
  background: transparent;
  min-height: calc(100vh - 64px);
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
}

.page-header-content h1 {
  margin: 0 0 8px 0;
  font-size: 24px;
  font-weight: 600;
  color: var(--text-primary);
}

.page-header-content p {
  margin: 0;
  font-size: 14px;
  color: var(--text-muted);
}

.page-header-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

.detail-card {
  margin-bottom: 16px;
}

.detail-card .ant-card-head {
  border-bottom: 1px solid var(--border);
}

.info-row {
  display: flex;
  padding: 12px 0;
  border-bottom: 1px solid var(--border);
}

.info-row:last-child {
  border-bottom: none;
}

.info-label {
  width: 200px;
  color: var(--text-muted);
  font-size: 14px;
}

.info-value {
  flex: 1 1;
  color: var(--text-primary);
  font-size: 14px;
}

.info-value code {
  background: var(--bg-elevated);
  color: var(--text-primary);
  padding: 2px 8px;
  border-radius: 3px;
  font-family: 'Courier New', monospace;
}

.app-name {
  font-weight: 500;
  font-size: 14px;
}

.bundle-id {
  font-family: 'Courier New', monospace;
  font-size: 12px;
  background: var(--bg-elevated);
  padding: 2px 8px;
  border-radius: 3px;
  color: var(--accent);
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.stat-card {
  text-align: center;
}

.stat-value {
  font-size: 32px;
  font-weight: 600;
  color: var(--accent);
  margin: 8px 0;
}

.stat-label {
  font-size: 14px;
  color: var(--text-muted);
}

.stat-change {
  font-size: 12px;
  margin-top: 4px;
}

.stat-change.positive {
  color: var(--success);
}

.stat-change.negative {
  color: var(--danger);
}

.campaign-push-item {
  display: flex;
  align-items: flex-start;
  padding: 16px;
  border: 1px solid var(--border);
  border-radius: 4px;
  margin-bottom: 12px;
  background: var(--bg-surface);
}

.campaign-push-order {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--accent);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  margin-right: 16px;
  flex-shrink: 0;
}

.campaign-push-content {
  flex: 1 1;
}

.campaign-push-title {
  font-weight: 500;
  margin-bottom: 4px;
}

.campaign-push-body {
  color: var(--text-secondary);
  font-size: 13px;
  margin-bottom: 8px;
}

.campaign-push-meta {
  font-size: 12px;
  color: var(--text-muted);
}

.campaign-push-actions {
  display: flex;
  gap: 8px;
}

.form-section {
  margin-bottom: 32px;
}

.form-section-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border);
}

.form-section-description {
  font-size: 13px;
  color: var(--text-muted);
  margin-top: -12px;
  margin-bottom: 16px;
}

.firebase-config {
  background: var(--bg-elevated);
  color: var(--text-primary);
  padding: 16px;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  font-size: 12px;
  max-height: 400px;
  overflow-y: auto;
}

.firebase-config-item {
  padding: 4px 0;
}

.firebase-config-key {
  color: var(--accent);
  font-weight: 600;
}

.firebase-config-value {
  color: var(--text-primary);
}

.empty-state {
  text-align: center;
  padding: 60px 0;
}

.empty-state-icon {
  font-size: 64px;
  color: var(--text-muted);
  margin-bottom: 16px;
}

.empty-state-title {
  font-size: 16px;
  color: var(--text-secondary);
  margin-bottom: 8px;
}

.empty-state-description {
  font-size: 14px;
  color: var(--text-muted);
  margin-bottom: 24px;
}

@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    gap: 16px;
  }

  .page-header-actions {
    width: 100%;
    flex-direction: column;
  }

  .page-header-actions > * {
    width: 100%;
  }

  .info-row {
    flex-direction: column;
    gap: 4px;
  }

  .info-label {
    width: 100%;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.status-badge.active {
  background: rgba(34, 197, 94, 0.12);
  color: var(--success);
  border: 1px solid rgba(34, 197, 94, 0.3);
}

.status-badge.inactive {
  background: var(--danger-bg);
  color: var(--danger);
  border: 1px solid rgba(248, 113, 113, 0.3);
}

.status-badge.scheduled {
  background: var(--accent-glow);
  color: var(--accent-hover);
  border: 1px solid rgba(59, 130, 246, 0.3);
}

.actions-group {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid var(--border);
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 18, 38, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.row-needs-attention > td {
  background-color: rgba(250, 173, 20, 0.08) !important;
}

.row-needs-attention:hover > td {
  background-color: rgba(250, 173, 20, 0.14) !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/Common.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD","sourcesContent":[".page-container {\n  padding: 24px;\n  background: transparent;\n  min-height: calc(100vh - 64px);\n}\n\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 24px;\n}\n\n.page-header-content h1 {\n  margin: 0 0 8px 0;\n  font-size: 24px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.page-header-content p {\n  margin: 0;\n  font-size: 14px;\n  color: var(--text-muted);\n}\n\n.page-header-actions {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.detail-card {\n  margin-bottom: 16px;\n}\n\n.detail-card .ant-card-head {\n  border-bottom: 1px solid var(--border);\n}\n\n.info-row {\n  display: flex;\n  padding: 12px 0;\n  border-bottom: 1px solid var(--border);\n}\n\n.info-row:last-child {\n  border-bottom: none;\n}\n\n.info-label {\n  width: 200px;\n  color: var(--text-muted);\n  font-size: 14px;\n}\n\n.info-value {\n  flex: 1;\n  color: var(--text-primary);\n  font-size: 14px;\n}\n\n.info-value code {\n  background: var(--bg-elevated);\n  color: var(--text-primary);\n  padding: 2px 8px;\n  border-radius: 3px;\n  font-family: 'Courier New', monospace;\n}\n\n.app-name {\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.bundle-id {\n  font-family: 'Courier New', monospace;\n  font-size: 12px;\n  background: var(--bg-elevated);\n  padding: 2px 8px;\n  border-radius: 3px;\n  color: var(--accent);\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.stat-card {\n  text-align: center;\n}\n\n.stat-value {\n  font-size: 32px;\n  font-weight: 600;\n  color: var(--accent);\n  margin: 8px 0;\n}\n\n.stat-label {\n  font-size: 14px;\n  color: var(--text-muted);\n}\n\n.stat-change {\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.stat-change.positive {\n  color: var(--success);\n}\n\n.stat-change.negative {\n  color: var(--danger);\n}\n\n.campaign-push-item {\n  display: flex;\n  align-items: flex-start;\n  padding: 16px;\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  margin-bottom: 12px;\n  background: var(--bg-surface);\n}\n\n.campaign-push-order {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: var(--accent);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  margin-right: 16px;\n  flex-shrink: 0;\n}\n\n.campaign-push-content {\n  flex: 1;\n}\n\n.campaign-push-title {\n  font-weight: 500;\n  margin-bottom: 4px;\n}\n\n.campaign-push-body {\n  color: var(--text-secondary);\n  font-size: 13px;\n  margin-bottom: 8px;\n}\n\n.campaign-push-meta {\n  font-size: 12px;\n  color: var(--text-muted);\n}\n\n.campaign-push-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.form-section {\n  margin-bottom: 32px;\n}\n\n.form-section-title {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 16px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid var(--border);\n}\n\n.form-section-description {\n  font-size: 13px;\n  color: var(--text-muted);\n  margin-top: -12px;\n  margin-bottom: 16px;\n}\n\n.firebase-config {\n  background: var(--bg-elevated);\n  color: var(--text-primary);\n  padding: 16px;\n  border-radius: 4px;\n  font-family: 'Courier New', monospace;\n  font-size: 12px;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.firebase-config-item {\n  padding: 4px 0;\n}\n\n.firebase-config-key {\n  color: var(--accent);\n  font-weight: 600;\n}\n\n.firebase-config-value {\n  color: var(--text-primary);\n}\n\n.empty-state {\n  text-align: center;\n  padding: 60px 0;\n}\n\n.empty-state-icon {\n  font-size: 64px;\n  color: var(--text-muted);\n  margin-bottom: 16px;\n}\n\n.empty-state-title {\n  font-size: 16px;\n  color: var(--text-secondary);\n  margin-bottom: 8px;\n}\n\n.empty-state-description {\n  font-size: 14px;\n  color: var(--text-muted);\n  margin-bottom: 24px;\n}\n\n@media (max-width: 768px) {\n  .page-header {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .page-header-actions {\n    width: 100%;\n    flex-direction: column;\n  }\n\n  .page-header-actions > * {\n    width: 100%;\n  }\n\n  .info-row {\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .info-label {\n    width: 100%;\n  }\n\n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.status-badge.active {\n  background: rgba(34, 197, 94, 0.12);\n  color: var(--success);\n  border: 1px solid rgba(34, 197, 94, 0.3);\n}\n\n.status-badge.inactive {\n  background: var(--danger-bg);\n  color: var(--danger);\n  border: 1px solid rgba(248, 113, 113, 0.3);\n}\n\n.status-badge.scheduled {\n  background: var(--accent-glow);\n  color: var(--accent-hover);\n  border: 1px solid rgba(59, 130, 246, 0.3);\n}\n\n.actions-group {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  padding-top: 16px;\n  border-top: 1px solid var(--border);\n}\n\n.loading-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(15, 18, 38, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n}\n\n.row-needs-attention > td {\n  background-color: rgba(250, 173, 20, 0.08) !important;\n}\n\n.row-needs-attention:hover > td {\n  background-color: rgba(250, 173, 20, 0.14) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
